import BaseRenderer from 'diagram-js/lib/draw/BaseRenderer';
import {
    append as svgAppend,
    attr as svgAttr,
    create as svgCreate,
    remove as svgRemove
} from 'tiny-svg';

import {
    getFillColor,
    getRoundRectPath, getStrokeColor
} from 'bpmn-js/lib/draw/BpmnRenderUtil';

import {is} from 'bpmn-js/lib/util/ModelUtil';
import {isAny} from 'bpmn-js/lib/features/modeling/util/ModelingUtil';

const HIGH_PRIORITY = 1500,
    TASK_BORDER_RADIUS = 2;


export default class CustomRenderer extends BaseRenderer {
    constructor(eventBus, bpmnRenderer) {
        super(eventBus, HIGH_PRIORITY);

        this.bpmnRenderer = bpmnRenderer;
        // this.handlers['bpmn:serviceProviderTask'] = function(parentGfx, element) {
        //     var task = renderer('bpmn:Task')(parentGfx, element);
        //
        //     var pathDataBG = pathMap.getScaledPath('TASK_TYPE_SERVICE', {
        //         abspos: {
        //             x: 12,
        //             y: 18
        //         }
        //     });
        //
        //     /* service bg */ drawPath(parentGfx, pathDataBG, {
        //         strokeWidth: 1,
        //         fill: getFillColor(element, defaultFillColor),
        //         stroke: getStrokeColor(element, defaultStrokeColor)
        //     });
        //
        //     var fillPathData = pathMap.getScaledPath('TASK_TYPE_SERVICE_FILL', {
        //         abspos: {
        //             x: 17.2,
        //             y: 18
        //         }
        //     });
        //
        //     /* service fill */ drawPath(parentGfx, fillPathData, {
        //         strokeWidth: 0,
        //         fill: getFillColor(element, defaultFillColor)
        //     });
        //
        //     var pathData = pathMap.getScaledPath('TASK_TYPE_SERVICE', {
        //         abspos: {
        //             x: 17,
        //             y: 22
        //         }
        //     });
        //
        //     /* service */ drawPath(parentGfx, pathData, {
        //         strokeWidth: 1,
        //         fill: getFillColor(element, defaultFillColor),
        //         stroke: getStrokeColor(element, defaultStrokeColor)
        //     });
        //
        //     return task;
        // }
    }

    canRender(element) {

        // only render tasks and events (ignore labels)
        return isAny(element, ['bpmn:Task', 'bpmn:Event']) && !element.labelTarget;
    }

    drawShape(parentNode, element) {
        const shape = this.bpmnRenderer.drawShape(parentNode, element);
        // const modeler = BpmnInit.bpmnModeler;
        // const overlays = modeler.get('overlays');
        // const image = element.businessObject.logo?element.businessObject.logo: '';
        // overlays.add(task, {
        //     html: `<div lass="img-overlay">
        //         <img id="serviceTask-logo" height="40" width="70" src="${image}">
        //       </div>`,
        //     position: {
        //         left: -5,
        //         top: -45
        //     }
        // });
        // if (is(element, 'bpmn:ServiceTask')) {
        //     const rect = drawRect(parentNode, 100, 80, TASK_BORDER_RADIUS, '#52B415');
        //     prependTo(rect, parentNode);
        //
        //     svgRemove(shape);
        //
        //     return shape;
        // }

        // const rect = drawRect(parentNode, 30, 20, TASK_BORDER_RADIUS, '#cc0000');
        //
        // svgAttr(rect, {
        //     transform: 'translate(-20, -10)'
        // });
        //
        // return shape;
    }

    getShapePath(shape) {
        if (is(shape, 'bpmn:Task')) {
            return getRoundRectPath(shape, TASK_BORDER_RADIUS);
        }

        return this.bpmnRenderer.getShapePath(shape);
    }
}

CustomRenderer.$inject = ['eventBus', 'bpmnRenderer'];

// helpers //////////

// copied from https://github.com/bpmn-io/bpmn-js/blob/master/lib/draw/BpmnRenderer.js
function drawRect(parentNode, width, height, borderRadius, strokeColor) {
    const rect = svgCreate('rect');

    svgAttr(rect, {
        width: width,
        height: height,
        rx: borderRadius,
        ry: borderRadius,
        stroke: strokeColor || '#000',
        strokeWidth: 2,
        fill: '#fff'
    });

    svgAppend(parentNode, rect);

    return rect;
}

// copied from https://github.com/bpmn-io/diagram-js/blob/master/lib/core/GraphicsFactory.js
function prependTo(newNode, parentNode, siblingNode) {
    parentNode.insertBefore(newNode, siblingNode || parentNode.firstChild);
}
